const navigationRoutes = {
  HOME: "/",
  ABOUT: "/about",
  PROGRAMS: "/programs",
  CONTACT: "/contact",
  DONATE: "/donate",
  DASHBOARD: "/dashboard",
  DEMO_LOGIN: "/portal",
  NOT_FOUND: "*",
  // School routes
  SCHOOL_AUTH: "/school/auth",
  SCHOOL_LOGIN: "/school/login",
  SCHOOL_DASHBOARD: "/school/dashboard",
  SCHOOL_ACTIVITIES: "/school/activities",
  SCHOOL_ACTIVITY_DETAIL: "/school/activities/:id",
  SCHOOL_SUBMISSIONS: "/school/submissions",
  SCHOOL_SUBMISSION_DETAIL: "/school/submissions/:id",
  SCHOOL_SUBMIT: "/school/submit/:id",
  SCHOOL_STUDENTS: "/school/students",
  SCHOOL_PROFILE: "/school/profile",
  SCHOOL_ONBOARDING: "/school/onboarding",
  // Admin routes
  ADMIN_DASHBOARD: "/admin/dashboard",
  ADMIN_SCHOOLS: "/admin/schools",
  ADMIN_SUBMISSIONS: "/admin/submissions",
  ADMIN_SUBMISSION_DETAIL: "/admin/submissions/:id",
  ADMIN_SUBMISSION_REPORTS: "/admin/submission-reports",
  ADMIN_ACTIVITY: "/admin/activity",
  ADMIN_ACTIVITY_DETAIL: "/admin/activity/:id",
  ADMIN_STUDENTS: "/admin/students",
  ADMIN_DONATIONS: "/admin/donations",
  ADMIN_SCHOOL_RANKINGS: "/admin/school-rankings",
  ADMIN_CERTIFICATES: "/admin/certificates",
  ADMIN_SETTINGS: "/admin/settings",
  ADMIN_LOGIN: "/admin/login",
  ADMIN_SCHOOL_APPROVAL: "/admin/school-approval",
  ADMIN_CONTACT_US: "/admin/contact-us",
};

/** Absolute app paths (no tenant id or /karuna segment in the URL). */
export const useKarunaLink = () => {
  return (path: string): string => {
    if (path === "/" || path === "") {
      return navigationRoutes.HOME;
    }
    return path.startsWith("/") ? path : `/${path}`;
  };
};

export const getKarunaLink = (path: string): string => {
  if (path === "/" || path === "") {
    return navigationRoutes.HOME;
  }
  return path.startsWith("/") ? path : `/${path}`;
};

export default navigationRoutes;
